import React, {PureComponent, ReactNode} from "react"
import {Dropdown as BootstrapDropdown} from "react-bootstrap"

import id from "@irati/utils/id"

import {DropdownMenu, StyledButtonToolbar, StyledHr, ToggleButton} from "./styled/Dropdown"

interface Props {
  pullRight?: boolean,
  header?: ReactNode,
  footer?: ReactNode,
  children: ReactNode,
  iconColor?: string,
  icon?: string,
  disabled?: boolean
}

interface State {
  open: boolean
}

class Dropdown extends PureComponent<Props, State> {
  static defaultProps = {
    pullRight: false,
    header: null,
    footer: null,
    iconColor: null,
    icon: "filter",
    disabled: false
  }

  state: State = {
    open: false
  }

  toggle = () => {
    const {disabled} = this.props
    if (!disabled) this.setState({open: !this.state.open})
  }

  close = () => this.setState({open: false})

  render() {
    const {pullRight, header, footer, children, iconColor, icon} = this.props
    const idNamespace = id("dropdown", this.props)
    const {open} = this.state
    return (
      <StyledButtonToolbar>
        <BootstrapDropdown id={idNamespace} open={open} onToggle={this.toggle} pullRight={pullRight} componentClass="div">
          <ToggleButton slim bsRole="toggle" icon={icon!} testing="true" color={iconColor} />
          <DropdownMenu bsRole="menu" onClick={this.close}>
            {header && (
              <>
                {" "}
                {header} <StyledHr />{" "}
              </>
            )}
            {children}
            {footer && (
              <>
                {" "}
                <StyledHr /> {footer}{" "}
              </>
            )}
          </DropdownMenu>
        </BootstrapDropdown>
      </StyledButtonToolbar>
    )
  }
}

export default Dropdown
